"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Equipamento = void 0;
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const typeorm_1 = require("typeorm");
let Equipamento = class Equipamento extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdEquipamento = void (0);
        this.nmEquipamento = void (0);
        this.idEquipamento = void (0);
        this.tpEquipamento = void (0);
        this.nmMarca = void (0);
        this.nmModelo = void (0);
        this.stEquipamento = void (0);
        this.cdLogradouro = void (0);
        this.dtInicial = void (0);
        this.dtFinal = void (0);
        this.txtObservacao = void (0);
        this.vlLatitude = void (0);
        this.vlLongitude = void (0);
        this.cdOrgao = void (0);
        this.nmHost = void (0);
        this.nrPort = void (0);
        this.nmPwd = void (0);
        this.nrChannel = void (0);
        this.nmLogin = void (0);
        this.nmUrlSnapshot = void (0);
        this.nmUrlStream = void (0);
        this.dsLocal = void (0);
        this.lgCriptografia = void (0);
        this.lgSyncFtp = void (0);
        this.dtAfericao = void (0);
        this.nrLacre = void (0);
        this.nrInventarioInmetro = void (0);
    }
};
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_equipamento", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "cdEquipamento", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_equipamento", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nmEquipamento", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "id_equipamento", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "idEquipamento", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "tp_equipamento", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "tpEquipamento", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_marca", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nmMarca", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_modelo", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nmModelo", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "st_equipamento", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "stEquipamento", void 0);
__decorate([
    typeorm_1.Column("integer", { primary: true, name: "cd_logradrouro", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "cdLogradouro", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "dt_inicial", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "dtInicial", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "dt_final", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "dtFinal", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "txt_observacao", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "txtObservacao", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "vl_latitude", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "vlLatitude", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "vl_longitude", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "vlLongitude", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "cd_orgao", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "cdOrgao", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_host", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nmHost", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "nr_port", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "nrPort", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_pwd", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nmPwd", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "nr_channel", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "nrChannel", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_login", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nmLogin", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_url_snapshot", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nmUrlSnapshot", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nm_url_stream", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nmUrlStream", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "ds_local", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "dsLocal", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_criptografia", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "lgCriptografia", void 0);
__decorate([
    typeorm_1.Column("integer", { name: "lg_sync_ftp", nullable: true }),
    __metadata("design:type", Number)
], Equipamento.prototype, "lgSyncFtp", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "dt_afericao", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "dtAfericao", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_lacre", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nrLacre", void 0);
__decorate([
    typeorm_1.Column("varchar", { name: "nr_inventario_inmetro", nullable: true }),
    __metadata("design:type", String)
], Equipamento.prototype, "nrInventarioInmetro", void 0);
Equipamento = __decorate([
    typeorm_1.Entity('grl_equipamento')
], Equipamento);
exports.Equipamento = Equipamento;
